import Config from './utils/config';
import Views from './views/views';
import Header from './components/Header';
import Fv from './components/Fv';
import Top from './views/top';
import ParticleAnime from './components/FvParticle';

let path = location.pathname;
if (path === '/sherlock/') {
  path = '/';
}

let param = location.search;
if (param.indexOf('vkfs_form') !== -1) {
  path = '/product/search/';
} else if (param.indexOf('?s=') !== -1) {
  path = '/search/';
}

class App {
  constructor() {
    this.config = new Config();
    this.views = new Views();
    this.header = new Header();
    if (path === '/') {
      this.fv = new Fv();
      this.top = new Top();
      this.particleAnime = new ParticleAnime();
      // fv
      window.addEventListener('DOMContentLoaded', function () {
        this.paragraph = document.querySelector('.js-kv-text');
        this.paragraphdesc = document.querySelectorAll('.js-kv-text-desc');
        this.textContent = this.paragraph.textContent;
      });
    }
  }
  render() {
    // loading
    if (path === '/wp' || path === '/') {
      const loadWindow = document.querySelector('.loadCont');
      const text = document.querySelector('.loadCont .txt');
      const body = document.querySelector('body');

      const keyName = 'loadingviewed';
      const keyValue = true;
      if (!sessionStorage.getItem(keyName)) {
        sessionStorage.setItem(keyName, keyValue);
        // first view
        body.style.opacity = 1;
        window.addEventListener('DOMContentLoaded', function () {
          gsap.fromTo(
            text,
            {
              autoAlpha: 0,
              willChange: 'opacity',
            },
            {
              autoAlpha: 1,
              delay: 0.3,
              duration: 1,
            },
          );
        });

        window.addEventListener('load', function () {
          this.newTextContent = [...this.textContent]
            .map((char) => `<span>${char}</span>`)
            .join('');
          this.paragraph.innerHTML = this.newTextContent;
          let tl = gsap.timeline();
          setTimeout(() => {
            tl.fromTo(
              '.js-kv-text span',
              {
                x: 8,
                autoAlpha: 0,
              },
              {
                duration: 5,
                delay: 0.5,
                x: 0,
                autoAlpha: 1,
                ease: 'expo.out',
                stagger: {
                  each: 0.1,
                  from: '0',
                  grid: 'auto',
                },
              },
            );
            gsap.fromTo(
              '.js-fv-title-sp',
              {
                autoAlpha: 0,
              },
              {
                autoAlpha: 1,
                duration: 9,
                delay: 0.5,
                ease: 'expo.out',
              },
            );
            gsap.fromTo(
              '.js-fade-in',
              {
                autoAlpha: 0,
              },
              {
                duration: 2,
                delay: 1,
                autoAlpha: 1,
                // ease: 'expo.out',
              },
            );
          }, 2000);
        });
        window.addEventListener('load', function () {
          setTimeout(() => {
            gsap.fromTo(
              text,
              {
                autoAlpha: 1,
              },
              {
                autoAlpha: 0,
                duration: 0.5,
              },
            );
            gsap.fromTo(
              loadWindow,
              {
                x: 0,
                rotate: '0.0001deg',
                willChange: 'transform',
              },
              {
                x: '-150%',
                delay: 0.8,
                duration: 0.7,
                ease: 'power2.out',
              },
            );
          }, 1500);
        });
      } else {
        window.addEventListener('load', function () {
          loadWindow.style.display = 'none';
          gsap.fromTo(
            '.js-fade-in',
            {
              autoAlpha: 0,
            },
            {
              duration: 2,
              delay: 1,
              autoAlpha: 1,
              // ease: 'expo.out',
            },
          );

          this.newTextContent = [...this.textContent]
            .map((char) => `<span>${char}</span>`)
            .join('');
          this.paragraph.innerHTML = this.newTextContent;
          let tl = gsap.timeline();
          tl.fromTo(
            '.js-kv-text span',
            {
              x: 8,
              autoAlpha: 0,
            },
            {
              duration: 5,
              delay: 0.5,
              x: 0,
              autoAlpha: 1,
              ease: 'expo.out',
              stagger: {
                each: 0.1,
                from: '0',
                grid: 'auto',
              },
            },
          );
          gsap.fromTo(
            '.js-fv-title-sp',
            {
              autoAlpha: 0,
            },
            {
              autoAlpha: 1,
              duration: 9,
              delay: 0.5,
              ease: 'expo.out',
            },
          );
          gsap.to(body, {
            opacity: 1,
            duration: 0.7,
          });
        });
      }
    }
    if (path === '/') {
      this.top.init();
      this.particleAnime.init();
      document.addEventListener('ready', function () {
        this.fv.init();
      });
    }
    this.config.init();
    this.views.init();
    this.header.init();
  }
}

export default App;
